export function normalizeHash (hash: number, min: number, max: number) {
  return Math.floor((hash % (max - min)) + min)
}
